export default "__VITE_PUBLIC_ASSET__35b87c89__"